var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-logo flex align-center justify-center",class:( _obj = {'nav-collapsed':_vm.collapseNav}, _obj[_vm.mode] = true, _obj )},[_c('div',{staticClass:"app-name",on:{"click":function($event){return _vm.goto('/')}}},[_c('img',{attrs:{"src":require("@/assets/images/logo3.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }